import Joi from "joi";

export const orderSchema = Joi.object({
  customer_name: Joi.string().required().label("Full Name"),
  customer_phone: Joi.number().required().label("Phone No."),
  customer_address: Joi.string().required().label("Address"),
  state: Joi.string().required().label("State"),
  district: Joi.string().required().label("District"),
  vdc_municipality: Joi.string().required().label("Area"),
  office_id: Joi.string().required().label("Office"),
});
